var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["type", "isActive", "children", "className", "nodeType", "disabled", "onClick"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import classnames from "classnames";
import { ArrowIcon, ArrowLightIcon } from "@riseart/icons";
import { tabsItemCls, tabsItemTitleCls, tabsItemDisabledCls, tabsItemActiveCls, tabsItemIconCls, tabsAccordionIconCls } from "./Tabs.less";
var noop = /* @__PURE__ */ __name(function noop2() {
}, "noop");
var DEFAULT_NODE_TYPE = "li";
var TabSideItem = /* @__PURE__ */ __name(function TabSideItem2(_ref) {
  var type = _ref.type, isActive = _ref.isActive, children = _ref.children, className = _ref.className, nodeType = _ref.nodeType, disabled = _ref.disabled, onClick = _ref.onClick, restProps = _objectWithoutProperties(_ref, _excluded);
  var TabComponent = nodeType || DEFAULT_NODE_TYPE;
  var handleClick = disabled ? noop : onClick;
  var IconComponent = isActive ? ArrowIcon : ArrowLightIcon;
  return /* @__PURE__ */ React.createElement(TabComponent, _extends({
    className: classnames(tabsItemCls, className, _defineProperty(_defineProperty({}, tabsItemActiveCls, isActive), tabsItemDisabledCls, disabled))
  }, restProps, {
    onClick: handleClick
  }), /* @__PURE__ */ React.createElement("span", {
    className: tabsItemTitleCls
  }, children), type === "accordion" ? /* @__PURE__ */ React.createElement("span", {
    className: tabsAccordionIconCls
  }) : /* @__PURE__ */ React.createElement(IconComponent, {
    className: tabsItemIconCls
  }));
}, "TabSideItem");
export {
  TabSideItem
};
